import React from "react";
import InputField from "../input/inputField";
import { useGetSchoolBranchesOptions } from "../../hooks/branchHooks/branch.hooks";
import Dropdown from "../Dropdown/dropdown";
import { DropdownOptions } from "../dropdownOptions";

interface Props {
  blockName: string;
  setBlockName: (blockName: string) => unknown;
  schoolBranchId: number | null;
  onBranchSelect: (branchId: number) => unknown;
}

export const BlockForm = ({
  blockName,
  setBlockName,
  schoolBranchId,
  onBranchSelect,
}: Props) => {
  const { isLoading: isSchoolBranchOptLoading, data: SCHOOL_BRANCH_OPTIONS } =
    useGetSchoolBranchesOptions();

  if (isSchoolBranchOptLoading) return <div />;

  return (
    <div className="flex flex-col">
      <InputField
        value={blockName}
        setValue={setBlockName}
        label="Block name"
        placeHolder="Enter block name"
      />

      <Dropdown
        label="Select school branch"
        options={SCHOOL_BRANCH_OPTIONS || []}
        selectedOption={
          (SCHOOL_BRANCH_OPTIONS || []).find(
            ({ value }) => value === schoolBranchId
          ) as DropdownOptions
        }
        setSelectedOption={(selectedOption: DropdownOptions) => {
          onBranchSelect(selectedOption.value as number);
        }}
      />
    </div>
  );
};
